import React from 'react';
import { isEqual } from 'lodash';

import { useDispatch, useSelector } from '../../redux/hooks';
import { selectMarketFilters, setMarketFilters } from '../../redux/actions/market';
import { fetchTenantProfile, selectTenantProfile } from '../../redux/actions/tenants';
import { fetchSettableMetadataForOrder, selectSettableMetadataForOrder } from '../../redux/actions/metadata';
import { getProfileRequirementIds } from '../../utils/metadata';

/** For carriers, keeps fulfilsProfile in sync with the profile's requirement ids unless "Alla uppdrag" was chosen. */
export default function useDefaultFulfilsProfile() {
    const dispatch = useDispatch();
    const filters = useSelector(selectMarketFilters());
    const tenantProfile = useSelector(selectTenantProfile());
    const settableMetadata = useSelector(selectSettableMetadataForOrder());
    const hasMetadataOptions = !!settableMetadata.vehicleTypeOptions;

    React.useEffect(() => {
        if (!tenantProfile) {
            dispatch(fetchTenantProfile());
        }
        if (!hasMetadataOptions) {
            dispatch(fetchSettableMetadataForOrder());
        }
    }, [dispatch, tenantProfile, hasMetadataOptions]);

    const { showAllAssignments, fulfilsProfile } = filters;
    React.useEffect(() => {
        if (!tenantProfile?.isCarrier || !hasMetadataOptions || showAllAssignments) return;
        const ids = getProfileRequirementIds(tenantProfile, settableMetadata);
        if (!isEqual(ids, fulfilsProfile)) {
            dispatch(setMarketFilters({ fulfilsProfile: ids }));
        }
    }, [dispatch, tenantProfile, settableMetadata, hasMetadataOptions, showAllAssignments, fulfilsProfile]);
}
